module.exports = __webpack_public_path__ + "media/menuju.41a793cd.mp3";